import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const LockIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="1 0 22 23"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M17.4001 9.75039H16.9001V8.05039C16.9001 5.01796 14.4325 2.55039 11.4001 2.55039C8.36767 2.55039 5.9001 5.01796 5.9001 8.05039V9.75039H5.4001C4.35247 9.75039 3.5001 10.6028 3.5001 11.6504V21.2504C3.5001 22.298 4.35247 23.1504 5.4001 23.1504H17.4001C18.4477 23.1504 19.3001 22.298 19.3001 21.2504V11.6504C19.3001 10.6028 18.4477 9.75039 17.4001 9.75039ZM7.3001 8.05039C7.3001 5.78962 9.13933 3.95039 11.4001 3.95039C13.6609 3.95039 15.5001 5.78962 15.5001 8.05039V9.75039H7.3001V8.05039ZM17.9001 21.2504C17.9001 21.383 17.8474 21.5102 17.7537 21.6039C17.6599 21.6977 17.5327 21.7504 17.4001 21.7504H5.4001C5.26749 21.7504 5.14031 21.6977 5.04654 21.6039C4.95278 21.5102 4.9001 21.383 4.9001 21.2504V11.6504C4.9001 11.5178 4.95278 11.3906 5.04654 11.2968C5.14031 11.2031 5.26749 11.1504 5.4001 11.1504H17.4001C17.5327 11.1504 17.6599 11.2031 17.7537 11.2968C17.8474 11.3906 17.9001 11.5178 17.9001 11.6504V21.2504Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};

export default memo(LockIcon);
